import React, { useEffect, useState } from "react"
import {
    Flex,
    View,
    DialogTrigger,
    ActionButton,
    Button,
    Item,
    TabList,
    TabPanels,
    Tabs,
    ProgressCircle,
} from "@adobe/react-spectrum"
import AddQueue from "./AddQueue"
import AddAdbandoned from "./AddAbandoned"
import Layout from "./Layout"
import AddConvWait from "./AddConvWait"
import AddOnQueueUsers from "./AddOnQueueUsers"
import AddVoiceMail from "./AddVoiceMail"
import Close from "@spectrum-icons/workflow/Close"
import {
    addNewAlert,
    getDefaultConfigs,
} from "../utilities/api/alertService-api"
import { connect } from "react-redux"
import { submitAlertConfiguration } from "./AlertValidation"
import { ToastContainer } from "react-toastify"
import AddConvWaitVolume from "./AddConvWaitVolume"
import AddContactHandled from "./AddContactHandled"
import AddCallbackScheduled from "./AddCallbackScheduled"
import AddHandled from "./AddContactHandled"
// import { data } from "./data"

function mapStateToProps(state) {
    return {
        user: state.login.userInfo,
        permissions:
            state.login.authorizedAccess != null
                ? state.login.authorizedAccess.permissions
                : [],
        token: state.login.token,
    }
}

const AddAlert = ({
    isDialogOpened,
    setIsDialogOpened,
    onClose,
    allQueues,
    selectedAlert,
    user,
    operation,
    fetchMonitoringQueueList,
    existingQueues,
    adminPermission,
    isEditable,
    defaultConfigs,
    isConfigsLoading,
}) => {
    // console.log("Data", data)
    const initialAlert = {
        queueId: "",
        queueName: "",
        channel: "",
        updatedBy: "",
        updatedDate: "",
        alertTypes: {
            wait: false,
            waitAlerts: [
                {
                    id: Math.floor(100000 + Math.random() * 900000),
                    alertOption: {
                        slack: true,
                        email: true,
                    },
                    recipient: {
                        emails: [" "],
                        slacks: [
                            {
                                channelName: "",
                                channelId: "",
                            },
                        ],
                    },
                    attribute: {
                        customAttribute: false,
                        customAttributes: [
                            {
                                attributeValues: [],
                                attributeName: "ORGID",
                                attributeValue: "",
                                items: [],
                                attributeCondition: "E",
                            },
                        ],
                    },
                    alertSubTypes: {
                        scheduled: true,
                        rescheduled: false,
                        cancelled: false,
                    },
                    schedule: {
                        customSchedules: [
                            {
                                timezone: "IST",
                                days: "MONDAY",
                                startTime: "*",
                                threshold: 0,
                                endTime: "*",
                            },
                        ],
                        custom: false,
                        threshold: 0,
                        everyday: true,
                    },
                    template: {
                        common: false,
                        custom: false,
                        emailSubject: "",
                        emailBody: "",
                        slackMessage: "",
                    },
                },
            ],
            onQueueUser: false,
            onQueueUsersAlerts: [
                {
                    id: Math.floor(100000 + Math.random() * 900000),
                    alertOption: {
                        slack: true,
                        email: true,
                    },
                    recipient: {
                        emails: [" "],
                        slacks: [
                            {
                                channelName: "",
                                channelId: "",
                            },
                        ],
                    },
                    attribute: {
                        customAttribute: false,
                        customAttributes: [
                            {
                                attributeValues: [],
                                attributeName: "ORGID",
                                attributeValue: "",
                                items: [],
                                attributeCondition: "E",
                            },
                        ],
                    },
                    alertSubTypes: {
                        scheduled: true,
                        rescheduled: false,
                        cancelled: false,
                    },
                    schedule: {
                        customSchedules: [
                            {
                                timezone: "IST",
                                days: "MONDAY",
                                startTime: "*",
                                threshold: 0,
                                endTime: "*",
                            },
                        ],
                        custom: false,
                        threshold: 0,
                        everyday: true,
                    },
                    template: {
                        common: false,
                        custom: false,
                        emailSubject: "",
                        emailBody: "",
                        slackMessage: "",
                    },
                },
            ],
            voicemail: false,
            voicemailAlerts: [
                {
                    id: Math.floor(100000 + Math.random() * 900000),
                    alertOption: {
                        slack: true,
                        email: true,
                    },
                    recipient: {
                        emails: [" "],
                        slacks: [
                            {
                                channelName: "",
                                channelId: "",
                            },
                        ],
                    },
                    attribute: {
                        customAttribute: false,
                        customAttributes: [
                            {
                                attributeValues: [],
                                attributeName: "ORGID",
                                attributeValue: "",
                                items: [],
                                attributeCondition: "E",
                            },
                        ],
                    },
                    alertSubTypes: {
                        scheduled: true,
                        rescheduled: false,
                        cancelled: false,
                    },
                    schedule: {
                        customSchedules: [
                            {
                                timezone: "IST",
                                days: "MONDAY",
                                startTime: "*",
                                threshold: 0,
                                endTime: "*",
                            },
                        ],
                        custom: false,
                        threshold: 0,
                        everyday: true,
                    },
                    template: {
                        common: false,
                        custom: false,
                        emailSubject: "",
                        emailBody: "",
                        slackMessage: "",
                    },
                },
            ],
            abandoned: false,
            abandonedAlerts: [
                {
                    id: Math.floor(100000 + Math.random() * 900000),
                    alertOption: {
                        slack: true,
                        email: true,
                    },
                    recipient: {
                        emails: [" "],
                        slacks: [
                            {
                                channelName: "",
                                channelId: "",
                            },
                        ],
                    },
                    attribute: {
                        customAttribute: false,
                        customAttributes: [
                            {
                                attributeValues: [],
                                attributeName: "ORGID",
                                attributeValue: "",
                                items: [],
                                attributeCondition: "E",
                            },
                        ],
                    },
                    alertSubTypes: {
                        scheduled: true,
                        rescheduled: false,
                        cancelled: false,
                    },
                    schedule: {
                        customSchedules: [
                            {
                                timezone: "IST",
                                days: "MONDAY",
                                startTime: "*",
                                threshold: 0,
                                endTime: "*",
                            },
                        ],
                        custom: false,
                        threshold: 0,
                        everyday: true,
                    },
                    template: {
                        common: false,
                        custom: false,
                        emailSubject: "",
                        emailBody: "",
                        slackMessage: "",
                    },
                },
            ],
            waitVolume: false,
            waitVolumeAlerts: [
                {
                    id: Math.floor(100000 + Math.random() * 900000),
                    alertOption: {
                        slack: true,
                        email: true,
                    },
                    recipient: {
                        emails: [" "],
                        slacks: [
                            {
                                channelName: "",
                                channelId: "",
                            },
                        ],
                    },
                    attribute: {
                        customAttribute: false,
                        customAttributes: [
                            {
                                attributeValues: [],
                                attributeName: "ORGID",
                                attributeValue: "",
                                items: [],
                                attributeCondition: "E",
                            },
                        ],
                    },
                    alertSubTypes: {
                        scheduled: true,
                        rescheduled: false,
                        cancelled: false,
                    },
                    schedule: {
                        customSchedules: [
                            {
                                timezone: "IST",
                                days: "MONDAY",
                                startTime: "*",
                                threshold: 0,
                                endTime: "*",
                            },
                        ],
                        custom: false,
                        threshold: 0,
                        everyday: true,
                    },
                    template: {
                        common: false,
                        custom: false,
                        emailSubject: "",
                        emailBody: "",
                        slackMessage: "",
                    },
                },
            ],
            handled: false,
            handledAlerts: [
                {
                    id: Math.floor(100000 + Math.random() * 900000),
                    alertOption: {
                        slack: true,
                        email: true,
                    },
                    recipient: {
                        emails: [" "],
                        slacks: [
                            {
                                channelName: "",
                                channelId: "",
                            },
                        ],
                    },
                    attribute: {
                        customAttribute: false,
                        customAttributes: [
                            {
                                attributeValues: [],
                                attributeName: "ORGID",
                                attributeValue: "",
                                items: [],
                                attributeCondition: "E",
                            },
                        ],
                    },
                    alertSubTypes: {
                        scheduled: true,
                        rescheduled: false,
                        cancelled: false,
                    },
                    schedule: {
                        customSchedules: [
                            {
                                timezone: "IST",
                                days: "MONDAY",
                                startTime: "*",
                                threshold: 0,
                                endTime: "*",
                            },
                        ],
                        custom: false,
                        threshold: 0,
                        everyday: true,
                    },
                    template: {
                        common: false,
                        custom: false,
                        emailSubject: "",
                        emailBody: "",
                        slackMessage: "",
                    },
                },
            ],
            callbackScheduled: false,
            callbackScheduledAlerts: [
                {
                    id: Math.floor(100000 + Math.random() * 900000),
                    individual: {
                        slack: true,
                        email: true,
                    },
                    customer: {
                        email: true,
                    },
                    alertOption: {
                        slack: true,
                        email: true,
                    },
                    recipient: {
                        emails: [" "],
                        slacks: [
                            {
                                channelName: "",
                                channelId: "",
                            },
                        ],
                    },
                    attribute: {
                        customAttribute: false,
                        customAttributes: [
                            {
                                attributeValues: [],
                                attributeName: "ORGID",
                                attributeValue: "",
                                items: [],
                                attributeCondition: "E",
                            },
                        ],
                    },
                    alertSubTypes: {
                        scheduled: true,
                        rescheduled: false,
                        cancelled: false,
                    },
                    schedule: {
                        customSchedules: [
                            {
                                timezone: "IST",
                                days: "MONDAY",
                                startTime: "*",
                                threshold: 0,
                                endTime: "*",
                            },
                        ],
                        custom: false,
                        threshold: 0,
                        everyday: true,
                    },
                    template: {
                        common: false,
                        custom: false,
                        emailSubject: "",
                        emailBody: "",
                        slackMessage: "",
                    },
                },
            ],
        },
    }

    const ldap = user?.userid
    const [alertService, setAlertService] = useState([initialAlert])
    const [selectedTab, setSelectedTab] = useState("queue")
    const [selectedAlerts, setSelectedAlerts] = useState([])
    const [selectedChannel, setSelectedChannel] = useState()
    const [templateData, setTemplateData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
    const alertOrder = [
        "abandoned",
        "handled",
        "callbackScheduled",
        "waitVolume",
        "onQueueUser",
        "voicemail",
        "wait",
    ]

    const sortedSelectedAlerts = [...selectedAlerts].sort((a, b) => {
        return alertOrder.indexOf(a) - alertOrder.indexOf(b)
    })

    useEffect(() => {
        if (operation !== "edit") {
            setSelectedAlerts([])
        }
    }, [selectedChannel])

    console.log("alertService line 505", alertService[0].alertTypes.callbackScheduledAlerts)

    useEffect(() => {
        if (selectedAlert.length) {
            setAlertService(selectedAlert)
            setSelectedChannel(selectedAlert[0].channel)
            const [alert] = selectedAlert
            const { alertTypes } = alert
            const alerts = []
            if (alertTypes.abandoned) alerts.push("abandoned")
            if (alertTypes.wait) alerts.push("wait")
            if (alertTypes.onQueueUser) alerts.push("onQueueUser")
            if (alertTypes.voicemail) alerts.push("voicemail")
            if (alertTypes.waitVolume) alerts.push("waitVolume")
            if (alertTypes.handled) alerts.push("handled")
            if (alertTypes.callbackScheduled) alerts.push("callbackScheduled")

            // Sort the alerts based on the defined order
            const sortedAlerts = alerts.sort((a, b) => {
                return alertOrder.indexOf(a) - alertOrder.indexOf(b)
            })
            setSelectedAlerts(sortedAlerts)
        }
    }, [selectedAlert, selectedChannel])

    useEffect(() => {
        setAlertService((prevState) => [
            {
                ...prevState[0],
                alertTypes: {
                    ...prevState[0].alertTypes,
                    wait: selectedAlerts.includes("wait"),
                    waitAlerts: selectedAlerts.includes("wait")
                        ? prevState[0].alertTypes.waitAlerts
                        : initialAlert.alertTypes.waitAlerts,
                    abandoned: selectedAlerts.includes("abandoned"),
                    abandonedAlerts: selectedAlerts.includes("abandoned")
                        ? prevState[0].alertTypes.abandonedAlerts
                        : initialAlert.alertTypes.abandonedAlerts,
                    onQueueUser: selectedAlerts.includes("onQueueUser"),
                    onQueueUsersAlerts: selectedAlerts.includes("onQueueUser")
                        ? prevState[0].alertTypes.onQueueUsersAlerts
                        : initialAlert.alertTypes.onQueueUsersAlerts,
                    voicemail: selectedAlerts.includes("voicemail"),
                    voicemailAlerts: selectedAlerts.includes("voicemail")
                        ? prevState[0].alertTypes.voicemailAlerts
                        : initialAlert.alertTypes.voicemailAlerts,
                    waitVolume: selectedAlerts.includes("waitVolume"),
                    waitVolumeAlerts: selectedAlerts.includes("waitVolume")
                        ? prevState[0].alertTypes.waitVolumeAlerts
                        : initialAlert.alertTypes.waitVolumeAlerts,
                    handled: selectedAlerts.includes("handled"),
                    handledAlerts: selectedAlerts.includes(
                        "handled"
                    )
                        ? prevState[0].alertTypes.handledAlerts
                        : initialAlert.alertTypes.handledAlerts,
                    callbackScheduled: selectedAlerts.includes(
                        "callbackScheduled"
                    ),
                    callbackScheduledAlerts: selectedAlerts.includes(
                        "callbackScheduled"
                    )
                        ? prevState[0].alertTypes.callbackScheduledAlerts
                        : initialAlert.alertTypes.callbackScheduledAlerts,
                },
            },
        ])
    }, [selectedAlerts])

    useEffect(() => {
        if (selectedChannel && selectedAlerts.length > 0 && defaultConfigs) {
            const channelData = defaultConfigs[selectedChannel.toLowerCase()]
            if (channelData) {
                const newTemplateData = {}
                selectedAlerts.forEach((alertType) => {
                    const key =
                        alertType === "onQueueUser" ? "onQueue" : alertType
                    if (channelData[key]) {
                        newTemplateData[alertType] = channelData[key]
                    }
                })
                setTemplateData(newTemplateData)
            }
        }
    }, [selectedChannel, selectedAlerts, defaultConfigs])

    const updateAbandonedState = (
        newAbandonedState,
        key = "abandonedAlerts"
    ) => {
        setAlertService((prevState) => [
            {
                ...prevState[0],
                alertTypes: {
                    ...prevState[0].alertTypes,
                    [key]: newAbandonedState,
                },
            },
        ])
    }

    const handleNext = () => {
        const tabKeys = ["queue", ...sortedSelectedAlerts]
        const currentIndex = tabKeys.indexOf(selectedTab)
        if (currentIndex < tabKeys.length - 1) {
            setSelectedTab(tabKeys[currentIndex + 1])
        }
    }

    const handlePrevious = () => {
        const tabKeys = ["queue", ...sortedSelectedAlerts]
        const currentIndex = tabKeys.indexOf(selectedTab)
        if (currentIndex > 0) {
            setSelectedTab(tabKeys[currentIndex - 1])
        }
    }

    const isLastSelectedAlert = () => {
        const tabKeys = ["queue", ...sortedSelectedAlerts]
        const currentIndex = tabKeys.indexOf(selectedTab)
        return currentIndex === tabKeys.length - 1
    }

    const canGoNext = !isLastSelectedAlert()
    const canGoPrevious = selectedTab !== "queue"

    useEffect(() => {
        return () => {
            setAlertService(alertService)
        }
    }, [])

    // console.log("alertService", alertService[0])

    const submitForm = (queueIn) => {
        queueIn.updatedBy = ldap
        queueIn.updatedDate = new Date().getTime()
        queueIn.channel = selectedChannel?.toLowerCase()
        if (submitAlertConfiguration(queueIn)) {
            addNewAlert(queueIn)
                .then((resp) => {
                    // props.close()
                    setIsDialogOpened(false)
                })
                .catch((err) => {
                    console.log({ err })
                })
                .finally(() => {
                    fetchMonitoringQueueList()
                })
        }
    }

    return (
        <DialogTrigger
            type="fullscreenTakeover"
            isOpen={isDialogOpened}
            defaultOpen={false}
            targetRef={document.getElementById("root")}
        >
            <ActionButton isHidden isQuiet></ActionButton>

            <Layout
                onNext={handleNext}
                onPrevious={handlePrevious}
                canGoNext={canGoNext}
                canGoPrevious={canGoPrevious}
                alertService={alertService}
                selectedChannel={selectedChannel}
                submitForm={submitForm}
                operation={operation}
                isEditable={isEditable}
            >
                <Flex direction="column" height="100%">
                    <Flex justifyContent="space-between">
                        <Tabs
                            aria-label="Add Alert"
                            selectedKey={selectedTab}
                            onSelectionChange={setSelectedTab}
                            height="100%"
                            width="100%"
                            isDisabled={isConfigsLoading}
                        >
                            <Flex width={"100%"}>
                                <TabList
                                    width={"100%"}
                                    UNSAFE_className="tabsPadding"
                                >
                                    <Item key="queue">Select Queue</Item>
                                    {sortedSelectedAlerts.includes(
                                        "abandoned"
                                    ) && (
                                        <Item key="abandoned">
                                            Abandoned Contact
                                        </Item>
                                    )}
                                     {sortedSelectedAlerts.includes(
                                        "callbackScheduled"
                                    ) && (
                                        <Item key="callbackScheduled">
                                            Callback Scheduled
                                        </Item>
                                    )}
                                    {sortedSelectedAlerts.includes(
                                        "handled"
                                    ) && (
                                        <Item key="handled">
                                            Contact Handled
                                        </Item>
                                    )}
                                   
                                    {sortedSelectedAlerts.includes(
                                        "waitVolume"
                                    ) && (
                                        <Item key="waitVolume">
                                            Contacts Waiting
                                        </Item>
                                    )}
                                    {sortedSelectedAlerts.includes(
                                        "onQueueUser"
                                    ) && (
                                        <Item key="onQueueUser">
                                            Users Available
                                        </Item>
                                    )}
                                    {sortedSelectedAlerts.includes(
                                        "voicemail"
                                    ) && <Item key="voicemail">Voicemail</Item>}
                                    {sortedSelectedAlerts.includes("wait") && (
                                        <Item key="wait">Wait Time</Item>
                                    )}
                                    
                                </TabList>
                                <Button
                                    UNSAFE_className="pointer"
                                    UNSAFE_style={{ borderRadius: "0px" }}
                                    onPress={onClose}
                                    style="fill"
                                    // minWidth="10px"
                                    // width={"5%"}
                                    variant="negative"
                                    // height={"100%"}
                                >
                                    <Close />
                                </Button>
                            </Flex>
                            <TabPanels>
                                <Item key="queue">
                                    <View>
                                        <AddQueue
                                            alertService={alertService}
                                            setAlertService={setAlertService}
                                            allQueues={allQueues}
                                            selectedAlerts={selectedAlerts}
                                            setSelectedAlerts={
                                                setSelectedAlerts
                                            }
                                            selectedChannel={selectedChannel}
                                            setSelectedChannel={
                                                setSelectedChannel
                                            }
                                            operation={operation}
                                            existingQueues={existingQueues}
                                            // adminPermission={adminPermission}
                                            isEditable={isEditable}
                                        />
                                    </View>
                                </Item>
                                {sortedSelectedAlerts.includes("abandoned") && (
                                    <Item key="abandoned">
                                        <View>
                                            {isLoading ? (
                                                <ProgressCircle />
                                            ) : error ? (
                                                <div>{error}</div>
                                            ) : (
                                                <AddAdbandoned
                                                    alertName="abandoned"
                                                    selectedAlert={
                                                        selectedAlert
                                                    }
                                                    selectedChannel={
                                                        selectedChannel
                                                    }
                                                    abandonedState={
                                                        alertService[0]
                                                            .alertTypes
                                                            .abandonedAlerts
                                                    }
                                                    updateAbandonedState={
                                                        updateAbandonedState
                                                    }
                                                    adminPermission={
                                                        adminPermission
                                                    }
                                                    queueName={
                                                        alertService[0]
                                                            .queueName
                                                    }
                                                    operation={operation}
                                                    isEditable={isEditable}
                                                    templateData={
                                                        templateData.abandoned
                                                    }
                                                />
                                            )}
                                        </View>
                                    </Item>
                                )}
                                {sortedSelectedAlerts.includes("wait") && (
                                    <Item key="wait">
                                        <View>
                                            <AddConvWait
                                                alertName="wait"
                                                selectedAlert={selectedAlert}
                                                selectedChannel={
                                                    selectedChannel
                                                }
                                                abandonedState={
                                                    alertService[0].alertTypes
                                                        .waitAlerts
                                                }
                                                updateAbandonedState={(value) =>
                                                    updateAbandonedState(
                                                        value,
                                                        "waitAlerts"
                                                    )
                                                }
                                                adminPermission={
                                                    adminPermission
                                                }
                                                queueName={
                                                    alertService[0].queueName
                                                }
                                                operation={operation}
                                                isEditable={isEditable}
                                                templateData={templateData.wait}
                                            />
                                        </View>
                                    </Item>
                                )}
                                {sortedSelectedAlerts.includes(
                                    "onQueueUser"
                                ) && (
                                    <Item key="onQueueUser">
                                        <View>
                                            <AddOnQueueUsers
                                                alertName="onQueueUser"
                                                selectedAlert={selectedAlert}
                                                selectedChannel={
                                                    selectedChannel
                                                }
                                                abandonedState={
                                                    alertService[0].alertTypes
                                                        .onQueueUsersAlerts
                                                }
                                                updateAbandonedState={(value) =>
                                                    updateAbandonedState(
                                                        value,
                                                        "onQueueUsersAlerts"
                                                    )
                                                }
                                                adminPermission={
                                                    adminPermission
                                                }
                                                queueName={
                                                    alertService[0].queueName
                                                }
                                                operation={operation}
                                                isEditable={isEditable}
                                                templateData={
                                                    templateData.onQueueUser
                                                }
                                            />
                                        </View>
                                    </Item>
                                )}
                                {sortedSelectedAlerts.includes("voicemail") && (
                                    <Item key="voicemail">
                                        <View>
                                            <AddVoiceMail
                                                alertName="voicemail"
                                                selectedAlert={selectedAlert}
                                                selectedChannel={
                                                    selectedChannel
                                                }
                                                abandonedState={
                                                    alertService[0].alertTypes
                                                        .voicemailAlerts
                                                }
                                                updateAbandonedState={(value) =>
                                                    updateAbandonedState(
                                                        value,
                                                        "voicemailAlerts"
                                                    )
                                                }
                                                adminPermission={
                                                    adminPermission
                                                }
                                                queueName={
                                                    alertService[0].queueName
                                                }
                                                operation={operation}
                                                isEditable={isEditable}
                                                templateData={
                                                    templateData.voicemail
                                                }
                                            />
                                        </View>
                                    </Item>
                                )}
                                {sortedSelectedAlerts.includes(
                                    "waitVolume"
                                ) && (
                                    <Item key="waitVolume">
                                        <View>
                                            <AddConvWaitVolume
                                                alertName="waitVolume"
                                                selectedAlert={selectedAlert}
                                                selectedChannel={
                                                    selectedChannel
                                                }
                                                abandonedState={
                                                    alertService[0].alertTypes
                                                        .waitVolumeAlerts
                                                }
                                                updateAbandonedState={(value) =>
                                                    updateAbandonedState(
                                                        value,
                                                        "waitVolumeAlerts"
                                                    )
                                                }
                                                adminPermission={
                                                    adminPermission
                                                }
                                                queueName={
                                                    alertService[0].queueName
                                                }
                                                operation={operation}
                                                isEditable={isEditable}
                                                templateData={
                                                    templateData.waitVolume
                                                }
                                            />
                                        </View>
                                    </Item>
                                )}
                                {sortedSelectedAlerts.includes(
                                    "handled"
                                ) && (
                                    <Item key="handled">
                                        <View>
                                            {isLoading ? (
                                                <ProgressCircle />
                                            ) : error ? (
                                                <div>{error}</div>
                                            ) : (
                                                <AddHandled
                                                    alertName="handled"
                                                    selectedAlert={
                                                        selectedAlert
                                                    }
                                                    selectedChannel={
                                                        selectedChannel
                                                    }
                                                    abandonedState={
                                                        alertService[0]
                                                            .alertTypes
                                                            .handledAlerts
                                                    }
                                                    updateAbandonedState={(value) =>
                                                        updateAbandonedState(
                                                            value,
                                                            "handledAlerts"
                                                        )
                                                    }
                                                    adminPermission={
                                                        adminPermission
                                                    }
                                                    queueName={
                                                        alertService[0]
                                                            .queueName
                                                    }
                                                    operation={operation}
                                                    isEditable={isEditable}
                                                    templateData={
                                                        templateData.handled
                                                    }
                                                />
                                            )}
                                        </View>
                                    </Item>
                                )}
                                {sortedSelectedAlerts.includes(
                                    "callbackScheduled"
                                ) && (
                                    <Item key="callbackScheduled">
                                        <View>
                                            {isLoading ? (
                                                <ProgressCircle />
                                            ) : error ? (
                                                <div>{error}</div>
                                            ) : (
                                                <AddCallbackScheduled
                                                    alertName="callbackScheduled"
                                                    selectedAlert={
                                                        selectedAlert
                                                    }
                                                    selectedChannel={
                                                        selectedChannel
                                                    }
                                                    abandonedState={
                                                        alertService[0]
                                                            .alertTypes
                                                            .callbackScheduledAlerts
                                                    }
                                                    updateAbandonedState={(value) =>
                                                        updateAbandonedState(
                                                            value,
                                                            "callbackScheduledAlerts"
                                                        )
                                                    }
                                                    adminPermission={
                                                        adminPermission
                                                    }
                                                    queueName={
                                                        alertService[0]
                                                            .queueName
                                                    }
                                                    operation={operation}
                                                    isEditable={isEditable}
                                                    templateData={
                                                        templateData.callbackScheduled
                                                    }
                                                />
                                            )}
                                        </View>
                                    </Item>
                                )}
                            </TabPanels>
                        </Tabs>
                    </Flex>
                </Flex>
                <ToastContainer enableMultiContainer containerId="modalToast" />
            </Layout>
        </DialogTrigger>
    )
}

export default connect(mapStateToProps)(AddAlert)
